
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as internalpsdI6It917bxq3WgSE35uT1SBWDZiq1ljFrmvYJZHb8Meta } from "/builds/tnr23/introfy/frontend/pages/internal.vue?macro=true";
import { default as indexWK2V8yUHNINCK4KLU8iiBXyucGiDzqKl7XlNJpEfrisMeta } from "/builds/tnr23/introfy/frontend/pages/internalarea/index.vue?macro=true";
import { default as candidatesNKQW5zCxFU4iQ_zBYUPxE5b56Ur9NHyYZtVZthVdkaoMeta } from "/builds/tnr23/introfy/frontend/pages/internalarea/candidates.vue?macro=true";
import { default as _91id_93EOWBFvJGNqyc_Lip5wEA6umQyw3Gr_45n6w6r3xnjhWAMMeta } from "/builds/tnr23/introfy/frontend/pages/internalarea/candidate/[id].vue?macro=true";
import { default as internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta } from "/builds/tnr23/introfy/frontend/pages/internalarea.vue?macro=true";
import { default as indexJQ4aE_45RKum_4578IB7nO_AIaZLBpmwF4zkzKeYKdb0rksMeta } from "/builds/tnr23/introfy/frontend/pages/candidatearea/index.vue?macro=true";
import { default as resumeGtyCmfekOJoenboxjNSxGy8Y4e8_iHkyk9TSW_7OmUAMeta } from "/builds/tnr23/introfy/frontend/pages/candidatearea/resume.vue?macro=true";
import { default as previewe6V6FXT0vdlKOGDVHDpHeB_16VundRB6f1lXmg3mbQwMeta } from "/builds/tnr23/introfy/frontend/pages/candidatearea/preview.vue?macro=true";
import { default as profile5r4jetBoJAQJa5Vm0UEJ6oJ5tWolbpM_45QUmJqAgXcNcMeta } from "/builds/tnr23/introfy/frontend/pages/candidatearea/profile.vue?macro=true";
import { default as inquiriesk44kfLXZOjziI1_h4eZSTdMinqsUilaMlCKWergIUocMeta } from "/builds/tnr23/introfy/frontend/pages/candidatearea/inquiries.vue?macro=true";
import { default as indexSzr98HFwUugT5wmAnyWK71k5NtOCBRZbjnHZOJF8Cv4Meta } from "/builds/tnr23/introfy/frontend/pages/candidatearea/videos/index.vue?macro=true";
import { default as recordocVTfHSQVQbhoSKWyraUsNRj1LkffNpiXk2KkCsHdT4Meta } from "/builds/tnr23/introfy/frontend/pages/candidatearea/videos/record.vue?macro=true";
import { default as candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta } from "/builds/tnr23/introfy/frontend/pages/candidatearea.vue?macro=true";
import { default as index_ajWd2OYGxFtLKOdz5v_nCJZsnEP0_45PkO82o428vRy4Meta } from "/builds/tnr23/introfy/frontend/pages/landing/index.vue?macro=true";
import { default as termsu3qMk1vs_bRasqBcHXalBH9o_qREklOoE4yV_dW9clwMeta } from "/builds/tnr23/introfy/frontend/pages/landing/terms.vue?macro=true";
import { default as imprintfI1EPHtFssbvLiHIaV9IGeontL_BofdAQeMf7t3ZkrgMeta } from "/builds/tnr23/introfy/frontend/pages/landing/imprint.vue?macro=true";
import { default as pricingh33QPNbwGSj9hjPxYM9gU1c8WMlPsqsd8eETKbuVULkMeta } from "/builds/tnr23/introfy/frontend/pages/landing/pricing.vue?macro=true";
import { default as privacyFVFqhBSneta3s7Cetpd534OTg4RuuRFBgEeWZmBnoHMMeta } from "/builds/tnr23/introfy/frontend/pages/landing/privacy.vue?macro=true";
import { default as employerF4c7GEfqeENJzK5G9C_QAxLZwlE0Hn9rNHEQ_45oNsvRMMeta } from "/builds/tnr23/introfy/frontend/pages/landing/employer.vue?macro=true";
import { default as candidate08dFZ9_45jf0i97FL3EUFdf_QWfC_45RoD2T4ge1YEnWXJwMeta } from "/builds/tnr23/introfy/frontend/pages/landing/candidate.vue?macro=true";
import { default as realestate0igI7nneaUYFK0LfXTT264P5swD5lsjvXA2Pq_KR1dYMeta } from "/builds/tnr23/introfy/frontend/pages/landing/realestate.vue?macro=true";
import { default as _91id_93CYppx1SqSJzoU191m25pg5_qasz8RxJVrLO3MSlXLd8Meta } from "/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile/[id].vue?macro=true";
import { default as candidatepublicprofileb0e_ZP_455PXDSifMwSVWW06fu6KkSk30zar_45ffbjlfmoMeta } from "/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile.vue?macro=true";
export default [
  {
    name: "internal___de",
    path: "/internal",
    meta: internalpsdI6It917bxq3WgSE35uT1SBWDZiq1ljFrmvYJZHb8Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internal.vue")
  },
  {
    name: "internal___en",
    path: "/en/internal",
    meta: internalpsdI6It917bxq3WgSE35uT1SBWDZiq1ljFrmvYJZHb8Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internal.vue")
  },
  {
    name: "internal___hu",
    path: "/hu/internal",
    meta: internalpsdI6It917bxq3WgSE35uT1SBWDZiq1ljFrmvYJZHb8Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internal.vue")
  },
  {
    name: "internal___tr",
    path: "/tr/internal",
    meta: internalpsdI6It917bxq3WgSE35uT1SBWDZiq1ljFrmvYJZHb8Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internal.vue")
  },
  {
    name: "internal___uk",
    path: "/uk/internal",
    meta: internalpsdI6It917bxq3WgSE35uT1SBWDZiq1ljFrmvYJZHb8Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internal.vue")
  },
  {
    name: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta?.name,
    path: "/internalarea",
    meta: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea.vue"),
    children: [
  {
    name: "internalarea___de",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/index.vue")
  },
  {
    name: "internalarea-candidates___de",
    path: "candidates",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidates.vue")
  },
  {
    name: "internalarea-candidate-id___de",
    path: "candidate/:id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidate/[id].vue")
  }
]
  },
  {
    name: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta?.name,
    path: "/en/internalarea",
    meta: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea.vue"),
    children: [
  {
    name: "internalarea___en",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/index.vue")
  },
  {
    name: "internalarea-candidates___en",
    path: "candidates",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidates.vue")
  },
  {
    name: "internalarea-candidate-id___en",
    path: "candidate/:id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidate/[id].vue")
  }
]
  },
  {
    name: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta?.name,
    path: "/hu/internalarea",
    meta: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea.vue"),
    children: [
  {
    name: "internalarea___hu",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/index.vue")
  },
  {
    name: "internalarea-candidates___hu",
    path: "candidates",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidates.vue")
  },
  {
    name: "internalarea-candidate-id___hu",
    path: "candidate/:id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidate/[id].vue")
  }
]
  },
  {
    name: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta?.name,
    path: "/tr/internalarea",
    meta: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea.vue"),
    children: [
  {
    name: "internalarea___tr",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/index.vue")
  },
  {
    name: "internalarea-candidates___tr",
    path: "candidates",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidates.vue")
  },
  {
    name: "internalarea-candidate-id___tr",
    path: "candidate/:id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidate/[id].vue")
  }
]
  },
  {
    name: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta?.name,
    path: "/uk/internalarea",
    meta: internalareaA9dl5A0_7KDK2q_7EyKLcBeK2TnfJOcd5DIh4Q0NK0EMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea.vue"),
    children: [
  {
    name: "internalarea___uk",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/index.vue")
  },
  {
    name: "internalarea-candidates___uk",
    path: "candidates",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidates.vue")
  },
  {
    name: "internalarea-candidate-id___uk",
    path: "candidate/:id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/internalarea/candidate/[id].vue")
  }
]
  },
  {
    name: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta?.name,
    path: "/candidatearea",
    meta: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea.vue"),
    children: [
  {
    name: "candidatearea___de",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/index.vue")
  },
  {
    name: "candidatearea-resume___de",
    path: "resume",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/resume.vue")
  },
  {
    name: "candidatearea-preview___de",
    path: "preview",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/preview.vue")
  },
  {
    name: "candidatearea-profile___de",
    path: "profile",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/profile.vue")
  },
  {
    name: "candidatearea-inquiries___de",
    path: "inquiries",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/inquiries.vue")
  },
  {
    name: "candidatearea-videos___de",
    path: "videos",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/index.vue")
  },
  {
    name: "candidatearea-videos-record___de",
    path: "videos/record",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/record.vue")
  }
]
  },
  {
    name: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta?.name,
    path: "/en/candidatearea",
    meta: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea.vue"),
    children: [
  {
    name: "candidatearea___en",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/index.vue")
  },
  {
    name: "candidatearea-resume___en",
    path: "resume",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/resume.vue")
  },
  {
    name: "candidatearea-preview___en",
    path: "preview",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/preview.vue")
  },
  {
    name: "candidatearea-profile___en",
    path: "profile",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/profile.vue")
  },
  {
    name: "candidatearea-inquiries___en",
    path: "inquiries",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/inquiries.vue")
  },
  {
    name: "candidatearea-videos___en",
    path: "videos",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/index.vue")
  },
  {
    name: "candidatearea-videos-record___en",
    path: "videos/record",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/record.vue")
  }
]
  },
  {
    name: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta?.name,
    path: "/hu/candidatearea",
    meta: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea.vue"),
    children: [
  {
    name: "candidatearea___hu",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/index.vue")
  },
  {
    name: "candidatearea-resume___hu",
    path: "resume",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/resume.vue")
  },
  {
    name: "candidatearea-preview___hu",
    path: "preview",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/preview.vue")
  },
  {
    name: "candidatearea-profile___hu",
    path: "profile",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/profile.vue")
  },
  {
    name: "candidatearea-inquiries___hu",
    path: "inquiries",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/inquiries.vue")
  },
  {
    name: "candidatearea-videos___hu",
    path: "videos",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/index.vue")
  },
  {
    name: "candidatearea-videos-record___hu",
    path: "videos/record",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/record.vue")
  }
]
  },
  {
    name: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta?.name,
    path: "/tr/candidatearea",
    meta: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea.vue"),
    children: [
  {
    name: "candidatearea___tr",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/index.vue")
  },
  {
    name: "candidatearea-resume___tr",
    path: "resume",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/resume.vue")
  },
  {
    name: "candidatearea-preview___tr",
    path: "preview",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/preview.vue")
  },
  {
    name: "candidatearea-profile___tr",
    path: "profile",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/profile.vue")
  },
  {
    name: "candidatearea-inquiries___tr",
    path: "inquiries",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/inquiries.vue")
  },
  {
    name: "candidatearea-videos___tr",
    path: "videos",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/index.vue")
  },
  {
    name: "candidatearea-videos-record___tr",
    path: "videos/record",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/record.vue")
  }
]
  },
  {
    name: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta?.name,
    path: "/uk/candidatearea",
    meta: candidateareax3_2QD43OG5NzNjcoWtxcDT4ajFMdzr2iVYygBHx7f4Meta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea.vue"),
    children: [
  {
    name: "candidatearea___uk",
    path: "",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/index.vue")
  },
  {
    name: "candidatearea-resume___uk",
    path: "resume",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/resume.vue")
  },
  {
    name: "candidatearea-preview___uk",
    path: "preview",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/preview.vue")
  },
  {
    name: "candidatearea-profile___uk",
    path: "profile",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/profile.vue")
  },
  {
    name: "candidatearea-inquiries___uk",
    path: "inquiries",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/inquiries.vue")
  },
  {
    name: "candidatearea-videos___uk",
    path: "videos",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/index.vue")
  },
  {
    name: "candidatearea-videos-record___uk",
    path: "videos/record",
    component: () => import("/builds/tnr23/introfy/frontend/pages/candidatearea/videos/record.vue")
  }
]
  },
  {
    name: "landing___de",
    path: "/",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/index.vue")
  },
  {
    name: "landing___en",
    path: "/en",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/index.vue")
  },
  {
    name: "landing___hu",
    path: "/hu",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/index.vue")
  },
  {
    name: "landing___tr",
    path: "/tr",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/index.vue")
  },
  {
    name: "landing___uk",
    path: "/uk",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/index.vue")
  },
  {
    name: "landing-terms___de",
    path: "/agb",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/terms.vue")
  },
  {
    name: "landing-terms___en",
    path: "/en/terms",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/terms.vue")
  },
  {
    name: "landing-terms___hu",
    path: "/hu/%C3%A1szf",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/terms.vue")
  },
  {
    name: "landing-terms___tr",
    path: "/tr/ko%C5%9Fullar",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/terms.vue")
  },
  {
    name: "landing-terms___uk",
    path: "/uk/%D1%83%D0%BC%D0%BE%D0%B2%D0%B8",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/terms.vue")
  },
  {
    name: "landing-imprint___de",
    path: "/impressum",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/imprint.vue")
  },
  {
    name: "landing-imprint___en",
    path: "/en/imprint",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/imprint.vue")
  },
  {
    name: "landing-imprint___hu",
    path: "/hu/impresszum",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/imprint.vue")
  },
  {
    name: "landing-imprint___tr",
    path: "/tr/k%C3%BCnye",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/imprint.vue")
  },
  {
    name: "landing-imprint___uk",
    path: "/uk/%D1%96%D0%BC%D0%BF%D1%80%D0%B5%D1%81%D1%83%D0%BC",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/imprint.vue")
  },
  {
    name: "landing-pricing___de",
    path: "/preise",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/pricing.vue")
  },
  {
    name: "landing-pricing___en",
    path: "/en/pricing",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/pricing.vue")
  },
  {
    name: "landing-pricing___hu",
    path: "/hu/%C3%A1rak",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/pricing.vue")
  },
  {
    name: "landing-pricing___tr",
    path: "/tr/fiyatlar",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/pricing.vue")
  },
  {
    name: "landing-pricing___uk",
    path: "/uk/%D1%86%D1%96%D0%BD%D0%B8",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/pricing.vue")
  },
  {
    name: "landing-privacy___de",
    path: "/datenschutz",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/privacy.vue")
  },
  {
    name: "landing-privacy___en",
    path: "/en/privacy",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/privacy.vue")
  },
  {
    name: "landing-privacy___hu",
    path: "/hu/adatv%C3%A9delem",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/privacy.vue")
  },
  {
    name: "landing-privacy___tr",
    path: "/tr/gizlilik",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/privacy.vue")
  },
  {
    name: "landing-privacy___uk",
    path: "/uk/%D0%BA%D0%BE%D0%BD%D1%84%D1%96%D0%B4%D0%B5%D0%BD%D1%86%D1%96%D0%B9%D0%BD%D1%96%D1%81%D1%82%D1%8C",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/privacy.vue")
  },
  {
    name: "landing-employer___de",
    path: "/arbeitgeber",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/employer.vue")
  },
  {
    name: "landing-employer___en",
    path: "/en/employers",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/employer.vue")
  },
  {
    name: "landing-employer___hu",
    path: "/hu/munkaad%C3%B3k",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/employer.vue")
  },
  {
    name: "landing-employer___tr",
    path: "/tr/i%C5%9Fverenler",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/employer.vue")
  },
  {
    name: "landing-employer___uk",
    path: "/uk/%D1%80%D0%BE%D0%B1%D0%BE%D1%82%D0%BE%D0%B4%D0%B0%D0%B2%D1%86%D1%96",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/employer.vue")
  },
  {
    name: "landing-candidate___de",
    path: "/kandidaten",
    meta: candidate08dFZ9_45jf0i97FL3EUFdf_QWfC_45RoD2T4ge1YEnWXJwMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidate.vue")
  },
  {
    name: "landing-candidate___en",
    path: "/en/candidates",
    meta: candidate08dFZ9_45jf0i97FL3EUFdf_QWfC_45RoD2T4ge1YEnWXJwMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidate.vue")
  },
  {
    name: "landing-candidate___hu",
    path: "/hu/tehets%C3%A9g",
    meta: candidate08dFZ9_45jf0i97FL3EUFdf_QWfC_45RoD2T4ge1YEnWXJwMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidate.vue")
  },
  {
    name: "landing-candidate___tr",
    path: "/tr/adaylar",
    meta: candidate08dFZ9_45jf0i97FL3EUFdf_QWfC_45RoD2T4ge1YEnWXJwMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidate.vue")
  },
  {
    name: "landing-candidate___uk",
    path: "/uk/%D0%BA%D0%B0%D0%BD%D0%B4%D0%B8%D0%B4%D0%B0%D1%82%D0%B8",
    meta: candidate08dFZ9_45jf0i97FL3EUFdf_QWfC_45RoD2T4ge1YEnWXJwMeta || {},
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidate.vue")
  },
  {
    name: "landing-realestate___de",
    path: "/immobilien",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/realestate.vue")
  },
  {
    name: "landing-realestate___en",
    path: "/en/realestate",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/realestate.vue")
  },
  {
    name: "landing-realestate___hu",
    path: "/hu/ingatlan",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/realestate.vue")
  },
  {
    name: "landing-realestate___tr",
    path: "/tr/emlak",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/realestate.vue")
  },
  {
    name: "landing-realestate___uk",
    path: "/uk/%D0%BD%D0%B5%D1%80%D1%83%D1%85%D0%BE%D0%BC%D1%96%D1%81%D1%82%D1%8C",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/realestate.vue")
  },
  {
    name: "landing-candidatepublicprofile___de",
    path: "/profil",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile.vue"),
    children: [
  {
    name: "landing-candidatepublicprofile-id___de",
    path: ":id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile/[id].vue")
  }
]
  },
  {
    name: "landing-candidatepublicprofile___en",
    path: "/en/profile",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile.vue"),
    children: [
  {
    name: "landing-candidatepublicprofile-id___en",
    path: ":id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile/[id].vue")
  }
]
  },
  {
    name: "landing-candidatepublicprofile___hu",
    path: "/hu/profil",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile.vue"),
    children: [
  {
    name: "landing-candidatepublicprofile-id___hu",
    path: ":id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile/[id].vue")
  }
]
  },
  {
    name: "landing-candidatepublicprofile___tr",
    path: "/tr/profile",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile.vue"),
    children: [
  {
    name: "landing-candidatepublicprofile-id___tr",
    path: ":id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile/[id].vue")
  }
]
  },
  {
    name: "landing-candidatepublicprofile___uk",
    path: "/uk/%D0%BF%D1%80%D0%BE%D1%84%D1%96%D0%BB%D1%8C",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile.vue"),
    children: [
  {
    name: "landing-candidatepublicprofile-id___uk",
    path: ":id()",
    component: () => import("/builds/tnr23/introfy/frontend/pages/landing/candidatepublicprofile/[id].vue")
  }
]
  }
]